import React from 'react';
import { useTranslation } from 'react-i18next';

import style from 'assets/scss/components/StayInformedCard.module.scss';
import { convertKeysToCamelCase } from '../helpers/baseHelper';
import useStayInformedCard from '../hooks/useStayInformedCard';
import TurnstileWidget from './common/TurnstileWidget';

function StayInformedCard(props) {
  const { newsletterTitle, newsletterDescription } = props;
  const { t } = useTranslation();
  const { register, handleSubmit, errors, turnstileProps } = useStayInformedCard();
  const {
    wrapper,
    detailsTitle,
    detailsContent,
    detailsEmail,
    detailsErrBig,
    detailsErrSmall,
    detailsTurnstile,
  } = convertKeysToCamelCase(style);

  return (
    <article className={`max-width ${wrapper}`}>
      <h2 className={detailsTitle}>{newsletterTitle || t('stay.informed.title')}</h2>
      <p className={detailsContent}>{newsletterDescription || t('stay.informed.content')}</p>
      <span className={detailsErrBig}>
        {errors?.email && <span className="errors">{t(`validation.${errors?.email?.message}`)}</span>}
      </span>
      <form onSubmit={handleSubmit} className={detailsEmail}>
        <input {...register('email')} placeholder={t('stay.informed.input.placeholder')} type="text" />
        <span className={detailsErrSmall}>
          {errors?.email && <span className="errors">{t(`validation.${errors?.email?.message}`)}</span>}
        </span>
        <button className="primary" type="submit">
          {t('general.buttons.signIn')}
        </button>
        {/* Last in source order so it wraps onto its own line below the row. */}
        <TurnstileWidget {...turnstileProps} className={detailsTurnstile} />
      </form>
    </article>
  );
}

export default StayInformedCard;
